(function () {
  'use strict';

  let angular = window.angular;
  let $ = window.jQuery;

  ApiKeyConfigurationController.$inject = [
    '$rootScope',
    'Customer',
    '$timeout',
    '$state',
    '$uibModal',
    'AppUtils',
  ];

  angular.module('app').component('connectionApiKey', {
    template:'<view-sidebar><view-sidebar-title><span translate>entities.apikey.modelName</span><div class="btn-group btn-group-sm pull-right"><a class="btn btn-primary" title="{{:: \'buttons.new\' | translate}} {{:: \'entities.apikey.modelName\' | translate}}" ng-click="ctrl.showApiKeyForm(null, null)"><i class="fas fa-plus"></i></a> <a class="btn btn-primary btn-sm" ng-class="{disabled: !ctrl.apiKeyId}" ui-sref=".({apiKeyId: null})"><i class="fas fa-ban"></i></a></div></view-sidebar-title><view-sidebar-content><js-tree data="ctrl.keysTree" selected="ctrl.apiKeyId" on-select="ctrl.onSelectApiKey(selected)"></js-tree><div class="absolute" ng-if="ctrl.loading"></div></view-sidebar-content></view-sidebar><div><view-sidebar-toggle></view-sidebar-toggle><div ng-hide="ctrl.apiKeySelected || ctrl.loading"><h1 class="centered-message no-margin"><i class="fas fa-arrow-circle-left"></i> <span translate>general._select.an</span> <span translate>entities.apikey.modelName</span></h1></div><div ng-if="ctrl.apiKeySelected" ng-show="!ctrl.loading"><div class="asset-profile"><div class="padding20"><div class="asset-name"><h2 title="{{ctrl.apiKeySelected.name}}" ng-class="{ \'text-danger\': ctrl.apiKeySelected.expiresAt && ctrl.now > ctrl.apiKeySelected.expiresAt, \'text-info\': !ctrl.apiKeySelected.expiresAt || ctrl.now < ctrl.apiKeySelected.expiresAt }">{{ctrl.apiKeySelected.name}}</h2><div class="btn-group"><a class="btn btn-primary btn-sm" ng-click="ctrl.showApiKeyForm(ctrl.apiKeySelected)"><i class="fas fa-edit"></i></a> <a class="btn btn-danger btn-sm" ng-click="ctrl.confirmRemoveApiKey(ctrl.apiKeySelected)"><i class="fas fa-trash"></i></a></div><div class="clearfix"></div></div><table class="table no-margin table-description"><thead><tr><th colspan="4" class="no-padding"></th></tr></thead><tbody><tr class="bordered"><td class="field" translate>entities.apikey.key</td><td class="clipboard" style="cursor: copy" clipboard data-text="ctrl.apiKeySelected.id">{{ctrl.apiKeySelected.id}} <button class="btn btn-default btn-sm btn-clipboard" title="Copy to clipboard"><i class="fas fa-copy"></i></button></td><td class="field" translate style="width: 90px">entities.apikey.expiresAt</td><td ng-class="{ \'text-danger\': ctrl.apiKeySelected.expiresAt && ctrl.now > ctrl.apiKeySelected.expiresAt, \'text-success\': !ctrl.apiKeySelected.expiresAt || ctrl.now < ctrl.apiKeySelected.expiresAt }"><strong ng-if="ctrl.apiKeySelected.expiresAt">{{ctrl.apiKeySelected.expiresAt | date: \'yyyy-MM-dd HH:mm\'}}</strong> <span ng-if="!ctrl.apiKeySelected.expiresAt">--</span></td></tr><tr class="bordered"><td class="field" style="width: 80px" translate>entities._all.enabled</td><td>{{ctrl.apiKeySelected.enabled}}</td><td class="field" style="width: 90px"><div class="nowrap" translate>entities.apikey.testMode</div></td><td>{{ctrl.apiKeySelected.testMode}}</td></tr></tbody></table></div></div></div><spinner show="ctrl.loading" css-class="\'small\'"></spinner></div>',
    controller: ApiKeyConfigurationController,
    controllerAs: 'ctrl',
    bindings: {
      $transition$: '<',
      apiKeys: '<',
      customer: '<',
    },
  });

  function ApiKeyConfigurationController($rootScope, Customer, $timeout, $state, $uibModal, utils) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.onSelectApiKey = onSelectApiKey;

      vm.keysTree = vm.apiKeys.tree;
      vm.apiKeys = utils.arrayToObject(vm.apiKeys.keys, 'id');

      // modals
      vm.showApiKeyForm = showApiKeyForm;
      vm.confirmRemoveApiKey = confirmRemoveApiKey;
      vm.apiKeySelected = null;

      checkKeyParam(vm.$transition$.params().apiKeyId);

      vm.uiOnParamsChanged = function (params) {
        if (params.apiKeyId !== undefined) {
          checkKeyParam(params.apiKeyId);
        }
      };
    };

    function showApiKeyForm(apiKey) {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        bindToController: true,
        keyboard: false,
        component: 'connectionApiKeyForm',
        resolve: {
          apiKey: apiKey,
          customer: vm.customer,
        },
      });

      instance.result
        .then(function (result) {
          if (result.operation === 'create') {
            $state.go('.', { apiKeyId: result.apiKey.id }, { reload: true });
          } else if (result.operation === 'update') {
            if (apiKey.name !== result.apiKey.name) {
              $rootScope.$broadcast('jstree.rename-node', result.node);
            }

            onSelectApiKey(result.apiKey.id);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function onSelectApiKey(selected) {
      if (!selected) {
        vm.apiKeySelected = null;
        return;
      }

      $state.go('.', { apiKeyId: selected });

      vm.loading = true;
      Customer.apiKeys
        .findById({
          id: vm.customer.id,
          fk: selected,
        })
        .$promise.then(function (key) {
          vm.now = new Date();
          vm.now.setDate(vm.now.getDate() + 1);
          if (utils.isValidNumber(key.ttl) && key.ttl > 0 && key.created) {
            const createdAt = (key.created = key.created.getTime
              ? key.created
              : new Date(key.created));

            const ttl = key.ttl * 1000;
            key.expiresAt = new Date(createdAt.getTime() + ttl);
          }

          vm.apiKeySelected = key;
          vm.loading = false;
        })
        .catch(function (err) {
          console.log(err);
          vm.loading = false;
        });
    }

    function confirmRemoveApiKey(apiKey) {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        windowClass: 'modal-xs modal-warning',
        bindToController: true,
        keyboard: false,
        component: 'connectionApiKeyRemove',
        resolve: {
          apiKey: apiKey,
          customer: vm.customer,
        },
      });

      instance.result
        .then(function () {
          $state.go('.', { apiKeyId: null }, { reload: true });
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function checkKeyParam(keyParam) {
      if (keyParam) {
        if (vm.apiKeys[keyParam]) {
          vm.apiKeyId = keyParam;
        } else {
          $state.go('.', { apiKeyId: null });
        }
      } else {
        vm.apiKeyId = null;
      }
    }
  }
})();
